export default __webpack_public_path__ + "static/media/22.4936dfd3.jpg";